/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const ProductPoolMutationResultDTOLocationEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const ProductPoolMutationResultDTOTypeEnum = {
    Keyword: 'KEYWORD',
    Store: 'STORE',
    Extension: 'EXTENSION'
};
/**
 * Check if a given object implements the ProductPoolMutationResultDTO interface.
 */
export function instanceOfProductPoolMutationResultDTO(value) {
    return true;
}
export function ProductPoolMutationResultDTOFromJSON(json) {
    return ProductPoolMutationResultDTOFromJSONTyped(json, false);
}
export function ProductPoolMutationResultDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'location': json['location'] == null ? undefined : json['location'],
        'type': json['type'] == null ? undefined : json['type'],
        'submitted': json['submitted'] == null ? undefined : json['submitted'],
        'added': json['added'] == null ? undefined : json['added'],
        'duplicates': json['duplicates'] == null ? undefined : json['duplicates'],
        'banned': json['banned'] == null ? undefined : json['banned'],
        'asinCount': json['asinCount'] == null ? undefined : json['asinCount'],
    };
}
export function ProductPoolMutationResultDTOToJSON(json) {
    return ProductPoolMutationResultDTOToJSONTyped(json, false);
}
export function ProductPoolMutationResultDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'location': value['location'],
        'type': value['type'],
        'submitted': value['submitted'],
        'added': value['added'],
        'duplicates': value['duplicates'],
        'banned': value['banned'],
        'asinCount': value['asinCount'],
    };
}
